import { browserSupportsWebAuthn } from '@simplewebauthn/browser';
import { useState } from 'react';
import { useAuth } from '../auth.tsx';
import { Centered } from '../components/Layout.tsx';
import { passkeyErrorMessage, signInWithPasskey } from '../passkeys.ts';

export function LoginPage() {
  const { state, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const supported = browserSupportsWebAuthn();
  const offline = state.status === 'signedOut' && state.offline;

  async function signIn() {
    setBusy(true);
    setError(null);
    try {
      setUser(await signInWithPasskey());
    } catch (e) {
      setError(passkeyErrorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Centered>
      <section className="card stack">
        <button type="button" className="btn primary block" onClick={signIn} disabled={busy || !supported}>
          {busy ? 'Waiting for your passkey…' : 'Sign in with passkey'}
        </button>
        {error && (
          <p className="error" role="alert">
            {error}
          </p>
        )}
        {!supported && <p className="error">This browser doesn’t support passkeys.</p>}
        {offline && <p className="notice">You’re offline. Connect to the internet to sign in.</p>}
        <p className="muted small">
          On a computer? Choose <strong>Use a phone or tablet</strong> and scan the QR code with the phone that has your
          passkey.
        </p>
        <p className="muted small">Squats is invite-only. New here? Ask for an invite link.</p>
      </section>
    </Centered>
  );
}
